import { render, staticRenderFns } from "./EmissionReport.vue?vue&type=template&id=4a64e306&"
import script from "./EmissionReport.vue?vue&type=script&lang=ts&"
export * from "./EmissionReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports